import React from "react";
import Reveal from "./Reveal";
import BrowserFrame from "./BrowserFrame";

// SEZIONE 3 — Showcase riutilizzabile (claim + mockup).
// `reverse` inverte l'ordine sx/dx (testo a destra, immagine a sinistra).
// `soft` applica lo sfondo peach soft (per l'alternanza tra sezioni).
export default function Showcase({
  id,
  eyebrow,
  title,
  body,
  imageSrc,
  imageAlt,
  reverse = false,
  soft = false,
}) {
  return (
    <section id={id} className={`showcase ${soft ? "showcase--soft" : ""}`.trim()}>
      <div className="container">
        <div className={`showcase-grid ${reverse ? "showcase-grid--reverse" : ""}`.trim()}>
          <Reveal className="showcase-copy">
            {eyebrow && <p className="section-label">{eyebrow}</p>}
            <h3 className="showcase-title">{title}</h3>
            <p className="showcase-body">{body}</p>
          </Reveal>

          <Reveal className="showcase-visual" delay={120}>
            <BrowserFrame src={imageSrc} alt={imageAlt} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
